import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Select, SpinnerSmall } from '@eyesee/eyesee-hub-npm-ui';
import { instructionStore, instructionStoreData } from '../../stores/instructionsStore';
import SaveButton from '../../components/SaveButton/SaveButton';
import '../DownloadInstructionsPage/instructions.scss';
import Translations from '../../components/Translations/Translations';
import { toJS } from 'mobx';
import ISO6391 from 'iso-639-1';
import { useFormik } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object({
    'INSTRUCTIONS': yup.string().required('Please fill in this field.'),
    'HELP BUTTON': yup.string().required('Please fill in this field.'),
    'click to see what is your current task': yup.string().required('Please fill in this field.'),
    'NEXT TASK BUTTON': yup.string().required('Please fill in this field.'),
    'when task finished, click to proceed': yup.string().required('Please fill in this field.'),
    'CLOSE BUTTON': yup.string().required('Please fill in this field.'),
    'click to close popup window': yup.string().required('Please fill in this field.'),
});
interface initialValues_t {
    [key: string]: string;
}
const ModalTransPage = observer(() => {
    const formik = useFormik({
        initialValues: {
            'INSTRUCTIONS': instructionStoreData.modalTranslations ? instructionStoreData.modalTranslations['INSTRUCTIONS'] : '',
            'HELP BUTTON': instructionStoreData.modalTranslations ? instructionStoreData.modalTranslations['HELP BUTTON'] : '',
            'click to see what is your current task': instructionStoreData.modalTranslations
                ? instructionStoreData.modalTranslations['click to see what is your current task']
                : '',
            'NEXT TASK BUTTON': instructionStoreData.modalTranslations ? instructionStoreData.modalTranslations['NEXT TASK BUTTON'] : '',
            'when task finished, click to proceed': instructionStoreData.modalTranslations
                ? instructionStoreData.modalTranslations['when task finished, click to proceed']
                : '',
            'CLOSE BUTTON': instructionStoreData.modalTranslations ? instructionStoreData.modalTranslations['CLOSE BUTTON'] : '',
            'click to close popup window': instructionStoreData.modalTranslations
                ? instructionStoreData.modalTranslations['click to close popup window']
                : '',
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values: initialValues_t) => {
            instructionStore.saveTranslation(instructionStoreData.selectedModalLang,'modalTranslation', values);
            instructionStore.getModalTranslations();
        },
    });

    useEffect(() => {
        instructionStore.getModalTranslations();
    }, []);
    let langNames = Object.keys(instructionStoreData.langList);
    const [selectedLang, setSelectedLang] = useState<string>('English');
    const onLangChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        instructionStoreData.editModalTranslations = false;
        instructionStoreData.selectedModalLang = instructionStoreData.langList[e.target.value].code;
        setSelectedLang(instructionStoreData.langList[e.target.value].name);
        instructionStore.getModalTranslations();
    };
    const handleChange = (key: string, e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (!instructionStoreData.editModalTranslations) return;
        formik.handleChange(e);
    };

    return (
        <div className="instructions-wrapper">
            <div className="instructions-wrapper__select">
                <p>Choose translation language</p>
                <Select title="Select language" onChange={onLangChange} options={langNames} value={selectedLang} />
                <button
                    onClick={() => {
                        instructionStoreData.editModalTranslations = true;
                    }}
                    className="btn c-btn edit-btn"
                >
                    <i title="Edit" className="material-icons prefix">
                        edit
                    </i>
                    Edit
                </button>
            </div>

            <div className="instructions-wrapper__text-wrapper ">
                {instructionStoreData.state === 'loading' ? (
                    <div className="project-spinner">
                        <SpinnerSmall />
                    </div>
                ) : (
                    <Translations edit={instructionStoreData.editModalTranslations} page={'popup'} formik={formik} onChange={handleChange} />
                    )}

            </div>
            <SaveButton title="Save" onClick={formik.handleSubmit} />
        </div>
    );
});
export default ModalTransPage;
